import { useQuery } from 'react-query';

import { axios } from 'lib/axios';

export const PLACES_MIN_INPUT_LENGTH = 3;

const searchPlaces = async ({ input, lang, isPublic }) => {
  const prefix = isPublic ? '/website' : '/api';
  const { data } = await axios.get(`${prefix}/places/autocomplete`, { params: { input, lang } });

  return data;
};

export const usePlaceSuggestions = ({ input, lang = 'en', isPublic = false }) =>
  useQuery(['placeSuggestions', isPublic, lang, input], () => searchPlaces({ input, lang, isPublic }), {
    enabled: input.trim().length >= PLACES_MIN_INPUT_LENGTH,
    select: ({ data }) => data ?? [],
    staleTime: 5 * 60 * 1000,
    keepPreviousData: true,
    retry: false,
  });
